////////////////////////Global////////////////////
export const ROOT = "/";
export const LOGIN = "/login";
export const RESETPASSWORD = "/reset-password";